// Widgets bind their listeners once per element and remember which
// elements they bound in memory, not in a data attribute. A binding
// never belongs in the markup: an attribute travels with any copy of the
// element's HTML and marks the copy bound with no listeners behind it.

// onceGuard returns a check for one widget's elements. It answers true
// the first time it sees an element, and false every time after.
export function onceGuard() {
  const bound = new WeakSet();

  return (el) => {
    if (bound.has(el)) return false;
    bound.add(el);

    return true;
  };
}
